/**
 *  @class
 *  @function ImageWithText
 *  Stamps the deferred <template class="background-video__deferred"> into the
 *  DOM when the section nears the viewport, then plays the video. Mirrors the
 *  pattern used by <background-video> and <slide-show>, but scoped to this
 *  section so theme-editor section reloads pick it up via connectedCallback.
 */
if (!customElements.get('image-with-text')) {
	class ImageWithText extends HTMLElement {
		connectedCallback() {
			this.video_container = this.querySelector('.image-with-text__image-media');
			if (!this.video_container) return;

			const template = this.video_container.querySelector('.background-video__deferred');
			if (!template) return;

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					observer.disconnect();
					const clone = template.content.cloneNode(true);
					template.replaceWith(clone);
					const iframe = this.video_container.querySelector('iframe');
					if (iframe) {
						iframe.onload = () => this.videoPlay();
					} else if (this.video_container.querySelector('video')) {
						this.videoPlay();
					}
				});
			}, { rootMargin: '100px' });
			observer.observe(this);
		}
		videoPlay() {
			setTimeout(() => {
				const provider = this.video_container.dataset.provider;
				if (provider === 'youtube') {
					this.video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
						event: "command",
						func: "playVideo",
						args: ""
					}), "*");
				} else if (provider === 'vimeo') {
					this.video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
						method: "play"
					}), "*");
				} else if (provider === 'hosted') {
					this.video_container.querySelector('video').play();
				}
			}, 10);
		}
	}
	customElements.define('image-with-text', ImageWithText);
}
